if ($(".admin_campeonatos_editar").length>0){
    var campeonatoTiposocio = {
        reenumerar: function(contenedor){
            contenedor.find('table tbody tr').each(function (k, v) {
                $(this).find('.inputTiposocio').attr('name', 'campeonatoTiposocio[' + k + '][id_mst_tiposocio]');
                $(this).find('input:radio.horasVista').attr('name', 'horasVista[' + k + ']');
                $(this).find('input:radio.diasVista').attr('name', 'diasVista[' + k + ']');
                $(this).find('.campeonatoTiposocioInputTextHorasVista').attr('name', 'campeonatoTiposocio[' + k + '][horas_vista]');
                $(this).find('.campeonatoTiposocioInputTextDiasVista').attr('name', 'campeonatoTiposocio[' + k + '][dias_vista]');
            });
        },
        anadirTiposocio: function (objeto){
            var contenedor = objeto.contenedor;
            var elimina = '';
            var options = '';
            var tiposocios = JSON.parse($("#tiposocios").val());
            if(contenedor.find('table tbody tr').length>0){
                elimina = '<div class="col-xs-1"><i class="fa fa-minus-square red pointer elimina campeonatoTiposocio"></i></div>';
                tiposocios.splice(0, 1);
            }else{
                //1r registre
                tiposocios = tiposocios[0];
            }

            $(tiposocios).each(function(k,e){
                var selected = '';
                if (typeof objeto.id_mst_tiposocio!=='undefined' && e.value== objeto.id_mst_tiposocio)
                    selected = 'selected';
                options += '<option '+selected+' value="'+e.value+'">'+e.text+'</option>';
            });

            var selectorTiposocios = '' +
                '<select name="campeonatoTiposocio[][id_mst_tiposocio]" style="margin-top:5px" class="form-control input-sm inputTiposocio">'+options+'</select>' +
                '';

            var horas_vista = $('<div>' +
                '<div class="radio"><label><input type="radio" class="horasVista noEspecificar" value="-1" name="horasVista">'+Lang.get('campeonato_grupo.SegunCampeonato')+'</label></div>' +
                '<div class="radio"><label><input type="radio" class="horasVista especificar" value="1" name="horasVista">'+Lang.get('msg.Especificar')+'</label></div>' +
                '<input type="number" class="form-control hidden campeonatoTiposocio campeonatoTiposocioInputTextHorasVista" value=""  name="campeonatoTiposocio[][horas_vista]"/>' +
                '</div>');

            var dias_vista = '' +
                '<div class="radio"><label><input type="radio" class="diasVista noEspecificar" value="-1" name="diasVista">'+Lang.get('campeonato_grupo.SegunCampeonato')+'</label></div>' +
                '<div class="radio"><label><input type="radio" class="diasVista especificar" value="1" name="diasVista">'+Lang.get('msg.Especificar')+'</label></div>' +
                '<input type="number" class="form-control hidden campeonatoTiposocio campeonatoTiposocioInputTextDiasVista" name="campeonatoTiposocio[][dias_vista]"/>' +
                '';


            var row = $(
                '<tr>' +
                '<td>'+selectorTiposocios+'</td>' +
                '<td class="horas_vista">'+horas_vista.html()+'</td>' +
                '<td class="dias_vista">'+dias_vista+'</td>' +
                '<td>'+elimina+'</td>' +
                '</tr>'
            );
            contenedor.find('table tbody').append(row);
            if (defined(objeto.horas_vista) && objeto.horas_vista>=0){
                contenedor.find('table tbody tr:last-child .campeonatoTiposocioInputTextHorasVista').val(objeto.horas_vista);
                contenedor.find('table tbody tr:last-child .horasVista.especificar').click();
            }else{
                contenedor.find('table tbody tr:last-child .horasVista.noEspecificar').click();
            }
            if (defined(objeto.dias_vista) && objeto.dias_vista>=0){
                contenedor.find('table tbody tr:last-child .campeonatoTiposocioInputTextDiasVista').val(objeto.dias_vista);
                contenedor.find('table tbody tr:last-child .diasVista.especificar').click();
            }else{
                contenedor.find('table tbody tr:last-child .diasVista.noEspecificar').click();
            }
            campeonatoTiposocio.reenumerar(contenedor);
        },
        especificar: function(e){
            if ($(e).val()=='-1') {
                $(e).closest('td').find('input.campeonatoTiposocio').addClass('hidden');
                $(e).closest('td').find('input.campeonatoTiposocio').val('');
            }
            if ($(e).val()=='1') {
                $(e).closest('td').find('input.campeonatoTiposocio').removeClass('hidden');
            }
        },
        anadirTiposocios: function(campeonatosTiposocio,table){
            //Anadimos los registros de la bbdd
            $.each(campeonatosTiposocio,function(k,v){
                campeonatoTiposocio.anadirTiposocio({'contenedor':$(table),'id_mst_tiposocio':v.id_mst_tiposocio,'horas_vista':v.horas_vista,'dias_vista':v.dias_vista})
            });
        },
        campeonatoTiposocioActivo: function (e) {
            var contenedor = $(e).closest('.contenedor');
            if ($(e).val() == '1') {
                contenedor.find(".campeonatoTiposocioTable").removeClass('hidden');
                if (contenedor.find(".campeonatoTiposocioTable table tbody tr").length == 0) {
                    campeonatoTiposocio.anadirTiposocio({contenedor: contenedor});
                }
            } else {
                contenedor.find(".campeonatoTiposocioTable").addClass('hidden');
            }
        },
        campeonato:{
          onload:function(){

                  var campeonatosTiposocio = JSON.parse($(".reg_campeonatos_tiposocio").val());
                  campeonatoTiposocio.anadirTiposocios(campeonatosTiposocio,$('#campeonatoTiposocioTable'));
                  if (campeonatosTiposocio.length > 0) {
                      $(".campeonatoTiposocioContenedor .campeonatoTiposocioActivo_1").click();
                  } else {
                      $(".campeonatoTiposocioContenedor .campeonatoTiposocioActivo_0").click();
                  }
                  campeonatoTiposocio.campeonato.permitir_reservar_usuario.comprobar();
                    campeonato.editar.entre_clubs.minimo_participantes.comprobar();
                    campeonato.editar.entre_clubs.maximo_participantes.comprobar();

          } ,
            permitir_reservar_usuario:{
                comprobar: function(){
                    if ($("#permitir_reservar_usuario_campeonato").val()=='1')
                        $(".admin_campeonatos_editar .campeonatoTiposocioContenedor").removeClass('hidden');
                    else
                        $(".admin_campeonatos_editar .campeonatoTiposocioContenedor").addClass('hidden');
                }
            }
        },
        campeonatoGrupo: {
            onload:function(){
                if ($(".reg_campeonatos_grupo_tiposocio").length>0) {
                    var campeonatosTiposocio = JSON.parse($(".reg_campeonatos_grupo_tiposocio").val());
                    campeonatoTiposocio.anadirTiposocios(campeonatosTiposocio, $('#campeonatoGrupoTiposocioTable'));
                    if (campeonatosTiposocio.length > 0) {
                        $('#campeonatoGrupoTiposocioTable').closest('.contenedor').find('.campeonatoTiposocioActivo_1').click();
                    } else {
                        $('#campeonatoGrupoTiposocioTable').closest('.contenedor').find('.campeonatoTiposocioActivo_0').click();
                    }
                    campeonatoTiposocio.campeonatoGrupo.permitir_reservar_usuario.comprobar();
                }


                campeonatoTiposocio.campeonatoGrupo.rankingmensual.comprobar();

                $(document).on('change','[name=ranking_mensual_partidos_semana_select]',function(){

                    campeonatoTiposocio.campeonatoGrupo.rankingmensual.comprobar();
                })
            },
            rankingmensual:{
                comprobar:function(){
                    if ($("[name=ranking_mensual_partidos_semana_select]").val() == undefined || $("[name=ranking_mensual_partidos_semana_select]").val()=='-1') {
                        $(".cg_ranking_mensual_partidos_semana_div").addClass('hidden');
                        $("[name=ranking_mensual_partidos_semana]").removeAttr('required');
                    }
                    else {
                        $(".cg_ranking_mensual_partidos_semana_div").removeClass('hidden');
                        $("[name=ranking_mensual_partidos_semana]").prop('required', true);
                    }
                }
            },
            permitir_reservar_usuario:{
                comprobar: function(){
                    //Se permite reservar
                    if ($("#permitir_reservar_usuario").val()=='1') {
                        $("#editarCampeonatoGrupoCrearGrupo .campeonatoTiposocioContenedor").removeClass('hidden');
                        $("#diasPuedereservar").removeClass('hidden');
                    }else if ($("#permitir_reservar_usuario").val()=='-1') {
                        //Se permite reservar segun campeonato
                        if ($("#permitir_reservar_usuario_campeonato").val()=='0') {
                            //El CAMPEONATO NO permite reservar
                            $("#editarCampeonatoGrupoCrearGrupo .campeonatoTiposocioContenedor").addClass('hidden');
                            $("#diasPuedereservar").addClass('hidden');
                        }else{
                            //El CAMPEONATO SI permite reservar
                            $("#editarCampeonatoGrupoCrearGrupo .campeonatoTiposocioContenedor").addClass('hidden');
                            $("#diasPuedereservar").removeClass('hidden');
                        }
                    }else{
                        //NO Se permite reservar
                        $("#editarCampeonatoGrupoCrearGrupo .campeonatoTiposocioContenedor").addClass('hidden');
                        $("#diasPuedereservar").addClass('hidden');
                    }
                }
            },

        }
    }




    /*Campeonato && CampeonatoGrupo
    * */

    var campeonato = {
        editar: {
            entre_clubs:{
                minimo_participantes:{
                    comprobar:function(){
                        $("[name=campeonato_minimo_participantes_especificar]:checked").val()>0?$("[name=campeonato_entre_clubs_minimo_participantes]").removeClass('hidden'):$("[name=campeonato_entre_clubs_minimo_participantes]").addClass('hidden');
                    }
                },
                maximo_participantes:{
                    comprobar:function(){
                        $("[name=campeonato_maximo_participantes_especificar]:checked").val()>0?$("[name=campeonato_entre_clubs_maximo_participantes]").removeClass('hidden'):$("[name=campeonato_entre_clubs_maximo_participantes]").addClass('hidden');
                    }
                }
            }
        }
    }

    $(document).on('click','[name=campeonato_minimo_participantes_especificar]',campeonato.editar.entre_clubs.minimo_participantes.comprobar);
    $(document).on('click','[name=campeonato_maximo_participantes_especificar]',campeonato.editar.entre_clubs.maximo_participantes.comprobar);


    function selectorRankingChange(contenedor) {
        var valor = parseInt($(contenedor).find(".selectorRanking").val());
        valor>0?$(contenedor).find(".adminEliminatoriaRanking").removeClass('hidden'):$(contenedor).find(".adminEliminatoriaRanking").addClass('hidden');
        valor>0?$(contenedor).find(".lligaPuntuacioRanking").removeClass('hidden'):$(contenedor).find(".lligaPuntuacioRanking").addClass('hidden');;
    }

    $(document).on('click','.campeonatoTiposocioTable input:radio.horasVista,.campeonatoTiposocioTable input:radio.diasVista',function(e){
        campeonatoTiposocio.especificar($(this));
    });

    $(document).on('click','.campeonatoTiposocio.elimina',function(e){
        var contenedor = $(this).closest('.campeonatoTiposocioTable');
        $(this).closest('tr').remove();
        campeonatoTiposocio.reenumerar(contenedor);
    });

    $(document).on('click','.campeonatoTiposocioAnadirBtn',function(){
        campeonatoTiposocio.anadirTiposocio({contenedor:$(this).closest('.campeonatoTiposocioTable')});
    });

    $(document).on('change','.admin_campeonatos_editar .selectorRanking',function(){
        selectorRankingChange($(".admin_campeonatos_editar"));
    });
    $(document).on('change','#editarCampeonatoGrupoCrearGrupo .selectorRanking',function(){
        selectorRankingChange($("#editarCampeonatoGrupoCrearGrupo"));
    });

    function adminEliminatoriaRankingNumEquiposChange(container){
        var puntosDiv = $(container).find('.puntosRonda');
        var numEquipos =  $(container).find('.adminEliminatoriaRankingNumEquipos').val();
        var numRondas = eliminatoriaNumeroRondas(numEquipos);
        puntosDiv.empty();
        for (var i = 0; i <= numRondas; i++) {
            var puntoRonda = $("#puntosRondaTemplate");
            puntosDiv.append(puntoRonda.html());
        }
        eliminatoriaRankingPuntosNombrarRondas(container);
    }

    $(document).on('change','.admin_campeonatos_editar .adminEliminatoriaRankingNumEquipos',function(){
        adminEliminatoriaRankingNumEquiposChange($(".admin_campeonatos_editar"));
    });
    $(document).on('change','#editarCampeonatoGrupoCrearGrupo .adminEliminatoriaRankingNumEquipos',function(){
        adminEliminatoriaRankingNumEquiposChange($("#editarCampeonatoGrupoCrearGrupo"));
    });

    /*
    * CampeonatoGrupo
    * */
    $(document).on('change','#permitir_reservar_usuario',function(){
        campeonatoTiposocio.campeonatoGrupo.permitir_reservar_usuario.comprobar();  
    });



    function showEditGrupFrmModal(id_reg_campeonatos_grupo, id_reg_campeonatos) {
        $.get('/view/campeonato/' + id_reg_campeonatos + '/campeonato_grupo/' + id_reg_campeonatos_grupo + '/editModal', function (data) {
            $("#showEditGrupFrmModal").html(data);
            $("#showEditGrupFrmModal").modal('show');
            js_reload();
            editarCampeonatoGrupoCompruebaSinInscritos();
            if ($('#activar_pago').val()=='1'){
                $("#activarPagoDiv .tiposIngresoPrecios").removeClass('hidden');
            }
            if ($("#reg_campeonatos_grupo_tiposocio_precio").length>0){
                var cgtiposocioPrecio = JSON.parse($("#reg_campeonatos_grupo_tiposocio_precio").val());
                $.each(cgtiposocioPrecio,function(k,v){
                    activarPago.anadirPrecio({'contenedor':$('#APprecios'),'id_mst_tiposocio':v.id_mst_tiposocio,'precio':v.precio})
                });
            }
            selectorRankingChange($("#editarCampeonatoGrupoCrearGrupo"));
            eliminatoriaRankingPuntosNombrarRondas($("#editarCampeonatoGrupoCrearGrupo"));
            campeonato_grupo.calcular_precio_reserva.comprobar();
            var dropzoneElement = $("#editarCampeonatoGrupoCrearGrupo").find('.dropzone_custom');
            dropzone_($(dropzoneElement),{url:$(dropzoneElement).data('url')});
            campeonatoColaboradorSortOutFunction();
            var diffDays = campeonatoEditar.duracionCampoenato();
            if (diffDays>15){
                $("#showEditGrupFrmModal [name=preferencia_horaria]").bootstrapSwitch('state', false);
                $("#showEditGrupFrmModal [name=preferencia_horaria]").bootstrapSwitch('disabled', true);
                $("#showEditGrupFrmModal .solicitar_preferencia_horaria .alert-warning").removeClass('hidden');
            }else{
                $("#showEditGrupFrmModal [name=preferencia_horaria]").bootstrapSwitch('disabled', false);
                $("#showEditGrupFrmModal .solicitar_preferencia_horaria .alert-warning").addClass('hidden');
            }

            campeonato_grupo.editar.entre_clubs.minimo_participantes.comprobar();
            campeonato_grupo.editar.entre_clubs.maximo_participantes.comprobar();
            campeonato_grupo.editar.entre_clubs.especificar_nombre.comprobar();

        });
    }



    /*Campeonato
     * */


    $(document).on('click','[name=campeonatoTiposocioActivo]',function(){
        campeonatoTiposocio.campeonatoTiposocioActivo($(this));
    });

    $(document).on('change','#permitir_reservar_usuario_campeonato',function(){
        campeonatoTiposocio.campeonato.permitir_reservar_usuario.comprobar();
    });

    $(function(){
        campeonatoTiposocio.campeonato.onload();
        selectorRankingChange($(".admin_campeonatos_editar"));
        eliminatoriaRankingPuntosNombrarRondas($(".admin_campeonatos_editar"));
    });

    $(document).on('click', ".campeonatoColaborador .btn-danger", function () {
        var self = $(this);
        var data = {
            id:self.closest('.image').data('id'),
            id_reg_campeonatos: self.closest('.dropzone_custom').data('id_reg_campeonatos'),
            id_reg_campeonatos_grupo: self.closest('.dropzone_custom').data('id_reg_campeonatos_grupo')
        };
        confirmDialog(Lang.get('msg.confirm_delete'))
            .yes(function () {
                $.post('/api/campeonato/imagenDelete', data,function () {
                    dropzone.imagePreview(self.closest('.dropzone_custom'));
                })
            });
    });

    $(document).on('click', ".campeonatoImagen .btn-danger", function () {
        var self = $(this);
        var data = {
            id_reg_campeonatos: self.closest('.dropzone_custom').data('id_reg_campeonatos'),
        };
        confirmDialog(Lang.get('msg.confirm_delete'))
            .yes(function () {
                $.post('/api/campeonato/imagenCampeonatoDelete', data,function () {
                    dropzone.imagePreview(self.closest('.dropzone_custom'));
                })
            });
    });

    $(document).off('click', ".dropzone_custom.document.campeonato .btn-danger").on('click', ".dropzone_custom.document.campeonato .btn-danger", function () {
        var self = $(this);
        var data = {
            id:self.closest('.document').data('id')
        };
        confirmDialog(Lang.get('msg.confirm_delete'))
            .yes(function () {
                $.post('/api/campeonato/documentDelete', data,function () {
                    dropzone.documentPreview(self.closest('.dropzone_custom'));
                })
            });
    });

    function campeonatoColaboradorSortOutFunction(){
        $(".campeonatoColaborador").on("sortout",function(){
            var ids = []
            $(this).find('.image').each(function(i,e){
                ids.push($(e).data('id'));
            });
            var data = {
                ids:ids,
                id_reg_campeonatos: $(this).data('id_reg_campeonatos'),
                id_reg_campeonatos_grupo: $(this).data('id_reg_campeonatos_grupo')
            }
            $.post('/api/campeonato/imagenOrden',data);
        });
        $(".dropzone_custom.document").on("sortout",function(){
            var ids = []
            $(this).find('.document').each(function(i,e){
                ids.push($(e).data('id'));
            });
            $.post('/api/campeonato/documentOrden',{ids:ids});
        });




    }
    campeonatoColaboradorSortOutFunction();

    /*Campeonatoeditar*/
    var campeonatoEditar = {
        admin_campeonatos_editar_form_beforeSubmit:function(){
            campeonatoEditar.tipo_puntuacion_sets.tipo_2.beforeSubmit();
        },
        duracionCampoenato:function(){
            var fecha_inicio = moment($("[name=fecha_inicio]").val(),'DD/MM/YYYY');
            var fecha_fin = moment($("[name=fecha_fin]").val(),'DD/MM/YYYY');
            var diffDays = Math.abs(fecha_inicio.diff(fecha_fin, 'days'));
            return diffDays;
        },
        fecha_fin: {
            change: function () {
                var diffDays = campeonatoEditar.duracionCampoenato()
                if (diffDays>15){
                    $("[name=preferencia_horaria]").bootstrapSwitch('state', false);
                    $("[name=preferencia_horaria]").bootstrapSwitch('disabled', true);
                    $(".solicitar_preferencia_horaria .alert-warning").removeClass('hidden');
                }else{
                    $("[name=preferencia_horaria]").bootstrapSwitch('disabled', false);
                    $(".solicitar_preferencia_horaria .alert-warning").addClass('hidden');
                }
            }
        },
        tipo_puntuacion_sets:{
            change:function(){
                campeonatoEditar.tipo_puntuacion_sets.checkSelector();
            },
            checkSelector:function(){
                var tipo_puntuacion_sets = parseInt($("[name=tipo_puntuacion_sets]").val());
                if (tipo_puntuacion_sets==1){
                    $("#selectorRankingFormGroup").removeClass('hidden');
                    $(".tipo_puntuacion_sets_1").removeClass('hidden');
                    $(".tipo_puntuacion_sets_2").addClass('hidden');
                    setTimeout(function(){
                        $(".tipo_puntuacion_sets_2 input.sets_ganados").removeAttr('required');
                        $(".tipo_puntuacion_sets_2 input.puntos").removeAttr('required');
                        $(".tipo_puntuacion_sets_2 #tipo_puntuacion_sets_puntos").removeAttr('required');
                    },300);
                }else{
                    $("#selectorRankingFormGroup").addClass('hidden');
                    $(".tipo_puntuacion_sets_1").addClass('hidden');
                    $(".tipo_puntuacion_sets_2").removeClass('hidden');
                    $(".tipo_puntuacion_sets_2 input.sets_ganados").prop('required',true);
                    $(".tipo_puntuacion_sets_2 input.puntos").prop('required',true);
                    $(".tipo_puntuacion_sets_2 #tipo_puntuacion_sets_puntos").prop('required',true);
                }
            },
            tipo_2:{
                puntuaciones:[],
                addField:function(input){

                    var sets_ganados = '0';
                    var puntos = '0';
                    if (input !== undefined)
                    {
                        sets_ganados = defined(input.sets_ganados) ? input.sets_ganados : '0';
                        puntos = defined(input.puntos) ? input.puntos : '0';
                    }
                    var randomId = "puntuaciones_randomId_"+Math.floor(Math.random() * 99999);

                    var linea = "<div class='form-group linea' id='"+randomId+"'><div class='col-xs-5'><input type='number' class='form-control sets_ganados' value='"+sets_ganados+"'/></div><div class='col-xs-5'><input type='number' step='.01' class='form-control puntos' value='"+puntos+"'/></div><div class='col-xs-2'><a onclick='campeonatoEditar.tipo_puntuacion_sets.tipo_2.deleteField(\""+randomId+"\")' class='btn btn-danger btn-xs' style='margin:0px'><i class='fa fa-times'></i></a></div></div></div>";
                    $(".tipo_puntuacion_sets_2 .lineas").append(linea);
                },
                deleteField:function(randomIdToDelete){
                    $("#"+randomIdToDelete).remove();
                },
                drawFields:function(){
                    $(".tipo_puntuacion_sets_2 .lineas").html('');
                    var title = "<div class='form-group'><div class='col-xs-6'>"+Lang.get('partido.Sets_ganados')+"</div><div class='col-xs-6'>"+Lang.get('campeonato_grupo.punts')+"</div></div>";
                    $(".tipo_puntuacion_sets_2 .lineas").append(title);
                    if (campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones.length==0)
                        campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones = [{'sets_ganados':'0','puntos':'0'}];
                    Object.keys(campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones).forEach(function(key) {
                        campeonatoEditar.tipo_puntuacion_sets.tipo_2.addField({
                            sets_ganados:campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones[key]['sets_ganados'],
                            puntos:campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones[key]['puntos'],
                        });
                    });
                },
                beforeSubmit:function (){
                    $(".tipo_puntuacion_sets_2 .inputs").html('');
                    $(".tipo_puntuacion_sets_2 .lineas .linea").each(function(key,linea){

                        var sets_ganados = $(linea).find('.sets_ganados').val();
                        var puntos = $(linea).find('.puntos').val();
                        var linea = "" +
                            "<input type='hidden' name='tipo_puntuacion_sets_puntos["+key+"][sets_ganados]' value='"+sets_ganados+"'/>" +
                            "<input type='hidden' name='tipo_puntuacion_sets_puntos["+key+"][puntos]' value='"+puntos+"' />" +
                            "";
                        $(".tipo_puntuacion_sets_2 .inputs").append(linea);
                    });
                },
                init:function(){
                    campeonatoEditar.tipo_puntuacion_sets.checkSelector();
                    campeonatoEditar.tipo_puntuacion_sets.tipo_2.puntuaciones = JSON.parse($("#tipo_puntuacion_sets_puntos").val());
                    campeonatoEditar.tipo_puntuacion_sets.tipo_2.drawFields();
                }
            },

        }
    }


    $(document).on('change', "[name=fecha_fin]", campeonatoEditar.fecha_fin.change);
    $(document).on('change', "[name=tipo_puntuacion_sets]", campeonatoEditar.tipo_puntuacion_sets.change);

    function admin_equipo_num(){
        if ($("#param_competicion_entre_equipos").val()=='0')
            return;
        var value = $('[name="entre_clubs"]:checked').val();
        switch (value){
            case '0':
                $("#admin_equipo_num_div").removeClass('hidden');
                $("#admin_entre_clubs_div").addClass('hidden');
                $("#permitir_reservar_usuario_campeonato").removeClass('hidden');
                $("#puedenReservarAlert1").addClass('hidden');
                break;
            case '1':
                $("#admin_equipo_num_div").addClass('hidden');
                $("#admin_entre_clubs_div").removeClass('hidden');
                $("#permitir_reservar_usuario_campeonato").val('0');
                $("#permitir_reservar_usuario_campeonato").addClass('hidden');
                $("#puedenReservarAlert1").removeClass('hidden');
                $("#selectPeriodicidad").val('14');
                selectPeriodicidad();
                break;
        }
    }

    function selectPeriodicidad(){
        var self = $("#selectPeriodicidad");
        if (self.val()=='7' || self.val()=='14'){
            $("#duracion_jornada").removeClass('hidden');
            if ($("[name=duracion_jornada]").val()==''){
                $("[name=duracion_jornada]").val(1);
            }
        }else{
            $("#duracion_jornada").addClass('hidden');

        }
    }
    $('[name="entre_clubs"]').change(admin_equipo_num);

    $("#selectPeriodicidad").change(selectPeriodicidad);


    $(function(){
        check_elements('onstart');
    });

}